import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';


const actualidad = {
	state: {
		noticias: '',
		promociones: '',
		categorias: []
	},
	getters: {
		getCategorias: (state) => state.categorias
	},
	actions: {
		requestActividades: ({ commit, getters }, data) => {

			return new Promise((resolve, reject) => {

				let query = {
					"filters": [
						{
							"name": "dates.date",
							"search": {
								"min": (data.date_start) ? data.date_start : '2022-01-01',
								"max": data.date_end
							}
						},
						{
							"name": "categories.slug",
							"search": [(data.subcategorie) ? data.subcategorie : data.categorie]
						}
					],
					columns: [
						{ name: 'categories', onlyLoad: true },
						{ name: 'dates', onlyLoad: true }
					]
				};

				axios.post('/api/activities/grouped', query).then(response => {
					resolve(response.data.data)
				}).catch(error => reject(error));

			});
		},
		ordenarActividades({ commit }, actividades) {
			return new Promise((resolve, reject) => {
			  try {
				// Convertir el objeto de actividades a un array
				let actividadesArray = [];
				for (const fecha in actividades) {
				  for (const id in actividades[fecha]) {
					actividadesArray.push(actividades[fecha][id]);
				  }
				}
		
				// Ordenar el array por fecha
				actividadesArray.sort((a, b) => {
				  const fechaA = a.dates[0] ? new Date(a.dates[0].date) : new Date();
				  const fechaB = b.dates[0] ? new Date(b.dates[0].date) : new Date();
				  return fechaA - fechaB;
				});
		
				// Convertir el array ordenado de vuelta a un objeto agrupado por fecha
				const actividadesOrdenadas = actividadesArray.reduce((acc, actividad) => {
				  const fecha = actividad.dates[0].date.split('T')[0]; // Formato YYYY-MM-DD
				  if (!acc[fecha]) {
					acc[fecha] = {};
				  }
				  acc[fecha][actividad.id] = actividad;
				  return acc;
				}, {});
		
				resolve(actividadesOrdenadas);
			  } catch (error) {
				reject('Error al ordenar actividades: ' + error);
			  }
			});
		  },		
		sendRegistro: ({ commit }, data) => {
			return new Promise((resolve, reject) => {
				axios.post(`/api/activities/add/group/${data.dateid}`, data).then(result => {
					resolve(result.data);
					$("form").reset();
				}).catch(error => {
					reject(false);
				});
			});
		},
		requestCategorias({ commit }) {

			let query = {
				columns: [
					{ name: 'childs', onlyLoad: true },
				]
			};

			return new Promise((resolve, reject) => {
				axios.post(`/api/categories`,query).then(result => {
					commit('setCategorias', result.data.data)
				}).catch(error => {
					reject(false);
				});
			});
		},
		requestCategoria({ commit }, slug) {
			return new Promise((resolve, reject) => {
				axios.get(`/api/categories/${slug}`).then(result => {
					commit('setCategorias', result.data.data)
				}).catch(error => {
					reject(false);
				});
			});
		}
	},
	mutations: {
		setNoticias: (state, noticias) => {
			state.noticias = noticias;
		},
		setPromociones: (state, promociones) => {
			state.promociones = promociones;
		},
		setCategorias: (state, categorias) => {
			state.categorias = categorias;
		}
	}
}

export default actualidad;



// WEBPACK FOOTER //
// ./src/store/actualidad.js